var _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 40,
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5 L35 35 L5 35 Z",
    fill: "#2e7d32"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 25,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 18,
    fill: "#2e7d32"
  }, "AVEN")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 35,
    fontFamily: "Arial",
    fontSize: 10,
    fill: "#757575"
  }, "HEALTH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvenLogo);
export default __webpack_public_path__ + "static/media/aven-logo.e67a01766ace3a96e13af09fcb4de369.svg";
export { ForwardRef as ReactComponent };